import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

import { Button, LinearProgress, withStyles } from "@material-ui/core";

import useSubscription from "../../Utils/useSubscription";
import { Container } from "./styles";

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 23,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: "rgba(45, 127, 173, 0.37)",
  },
  bar: {
    borderRadius: 0,
    backgroundColor: "#2D7FAD",
  },
}))(LinearProgress);

function UpgradeCta({ onClick }) {
  const { isSubscriber } = useSubscription();

  return (
    <Container>
      {/* <h2>{remaining >= 0 ? remaining : 0} pedidos restantes</h2>
      <BorderLinearProgress variant="determinate" value={percentualUsed} /> */}
      <NavLink onClick={onClick} activeClassName="selected" to="/plans">
        {!isSubscriber && (
          <Button
            fullWidth
            size="large"
            variant="contained"
            color="primary"
            type="submit"
          >
            Assinar Agora
          </Button>
        )}
      </NavLink>
    </Container>
  );
}

export default UpgradeCta;
